export default __webpack_public_path__ + "static/media/twiter.723daf64.svg";